import React from "react";
import { useState, useEffect } from "react";
import {
  Header,
  Container,
  Title,
  Description,
  Footer,
  AddBusinessUpperBox,
  TicketDetails,
  AddSSSBox,
  AuthBox,
  AddAdress,
  AuthButton,
} from "../../../../components";
import styles from "./style.module.css";
import okkologo from "../../../../assets/okkoadminlogo.svg";
import userlogo from "../../../../assets/userlogowhite.svg";
import menu from "../../../../assets/menuwhite.svg";
import AddressMap from "../../../../components/AddressMap";
import useAxiosClient from "../../../../hooks/useAxiosClient";
import { successMessage } from "../../../../helpers/toast";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { API_URL } from "../../../../utils/url";
import AddBeyanBox from "../../../../components/Box/AddBeyanBox";

const EditBusiness = () => {
  const { isletmeId } = useParams();
  const axiosClient = useAxiosClient();
  const navigate = useNavigate();

  const [photo, setPhoto] = useState();
  const [businessName, setBusinessName] = useState();
  const [businessDesc, setBusinessDesc] = useState();
  const [businessInputsArray, setBusinessInputsArray] = useState([
    { name: "", price: "", campaign_price: "", slots: "", time_interval: "" },
  ]);
  const [sssArray, setSssArray] = useState([{ question: "", answer: "", is_delete: false }]);
  const [beyanArray, setBeyanArray] = useState([{ beyan: "", is_delete: false }]);
  const [address, setAddress] = useState("");
  const [phone, setPhone] = useState("");
  const [location, setLocation] = useState("");
  const [businessExtraDesc, setBusinessExtraDesc] = useState("");
  const [workingHours, setWorkingHours] = useState("");
  const [isBusinessOpen, setIsBusinessOpen] = useState(false);

  const handleOpenClick = () => {
    setIsBusinessOpen(true);
  };

  const handleCloseClick = () => {
    setIsBusinessOpen(false);
  };

  const getBusiness = async () => {
    try {
      const response = await axiosClient.get(`/superuser/get-branch/branch-id=${isletmeId}`);

      setBusinessName(response?.data?.data?.branch?.name);
      setBusinessDesc(response?.data?.data?.branch?.description);
      setAddress(response?.data?.data?.branch?.address);
      setPhone(response?.data?.data?.branch?.phone);
      setLocation(response?.data?.data?.branch?.location);
      setBusinessExtraDesc(response?.data?.data?.working_hours?.additional_details);
      setWorkingHours(response?.data?.data?.working_hours?.hours);
      setPhoto(response?.data?.data?.branch?.image);
      setIsBusinessOpen(response?.data?.data?.branch?.is_active);
      // setPhoto(response?.data?.data?.branch?.image);
      //if response?.data?.data?.tickets.name null set ticket_name
      setBusinessInputsArray([]);
      response.data.data.tickets.map((item, index) => {
        setBusinessInputsArray((prev) => {
          return [
            ...prev,
            {
              name: item.ticket_name,
              price: item.price,
              campaign_price: item.campaign_price,
              slots: item.slots,
              time_interval: item.time_interval,
              is_delete: false,
              id: item.id,
            },
          ];
        });
      });

      setBeyanArray([]);
      response.data.data.beyanlar.map((item, index) => {
        setBeyanArray((prev) => {
          return [
            ...prev,
            {
              beyan: item.beyan,
              is_delete: false,
              id: item.id,
            },
          ];
        });
      });

      // setBusinessInputsArray(response?.data?.data?.tickets);
      setSssArray([]);
      response.data.data.faq.map((item, index) => {
        setSssArray((prev) => {
          return [
            ...prev,
            {
              question: item.question,
              answer: item.answer,
              is_delete: false,
              id: item.id,
            },
          ];
        });
      });
    } catch (error) {}
  };

  useEffect(() => {
    getBusiness();
  }, []);

  const addBusiness = async () => {
    try {
      let formdata = new FormData();
      formdata.append("branch_name", businessName);
      formdata.append("branch_description", businessDesc);
      formdata.append("branch_image", photo);
      formdata.append("address", address);
      formdata.append("phone", phone);
      formdata.append("location", location);
      formdata.append("additional_details", businessExtraDesc);
      formdata.append("hours", workingHours);
      businessInputsArray.map((item, index) => {
        delete item.created_at;
      });
      formdata.append("tickets", JSON.stringify(businessInputsArray));
      sssArray.map((item, index) => {
        delete item.created_at;
      });
      formdata.append("faq_questions", JSON.stringify(sssArray));
      beyanArray.map((item, index) => {
        delete item.created_at;
      });
      formdata.append("beyanlar", JSON.stringify(beyanArray));
      formdata.append("is_active", isBusinessOpen);

      const response = await axiosClient.patch(`/superuser/edit-branch/branch-id=${isletmeId}`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      successMessage("İşletme başarıyla düzenlendi.");
      // navigate("/admin");
    } catch (error) {}
  };

  return (
    <div className="grid grid-rows-layoutAuth ">
      <Header
        className="bg-primary"
        okkoLogo={okkologo}
        userIcon={userlogo}
        menuIcon={menu}
        profileLink={"/profil"}
        homeLink={"/admin"}
      />
      <Container className={styles.container}>
        <Title className={styles.upperTitle}>Macera, Adrenalin, Mutluluk...</Title>
        <Description className={styles.description}>Eğlencenin merkezine hoş geldin!</Description>
        <AddBusinessUpperBox
          photo={photo}
          setPhoto={setPhoto}
          businessName={businessName}
          setBusinessName={setBusinessName}
          businessDesc={businessDesc}
          setBusinessDesc={setBusinessDesc}
        />

        <div className="mt-10">
          <button
            className={`${
              isBusinessOpen ? "bg-blue-500 text-white" : "bg-white text-black"
            } text-black border w-40 px-4 py-2 rounded`}
            onClick={handleOpenClick}
          >
            İşletme Açık
          </button>
          <button
            className={`${
              isBusinessOpen ? "bg-white text-black" : "bg-blue-500 text-white"
            } text-black border px-4 py-2 w-40 rounded ml-2`}
            onClick={handleCloseClick}
          >
            İşletme Kapalı
          </button>
        </div>

        <TicketDetails
          businessInputsArray={businessInputsArray}
          setBusinessInputsArray={setBusinessInputsArray}
          businessTitle={businessName}
          setBusinessTitle={setBusinessName}
          businessExtraDesc={businessExtraDesc}
          setBusinessExtraDesc={setBusinessExtraDesc}
          workingHours={workingHours}
          setWorkingHours={setWorkingHours}
        />

        <AddBeyanBox beyanArray={beyanArray} setBeyanArray={setBeyanArray} className="w-full" />
        <AddSSSBox sssArray={sssArray} setSssArray={setSssArray} className="w-full" />

        <AddAdress
          address={address}
          setAddress={setAddress}
          phone={phone}
          setPhone={setPhone}
          location={location}
          setLocation={setLocation}
        >
          {" "}
        </AddAdress>
        <AuthButton className="w-full mt-20" clickButton={addBusiness}>
          TAMAMLA
        </AuthButton>
      </Container>
      <Footer showBg={false} />
    </div>
  );
};

export default EditBusiness;
